var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntermittentFasting = function SvgIntermittentFasting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z",
    fill: "#FC435F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43C34.4934 43 43 34.4934 43 24C43 13.5066 34.4934 5 24 5C13.5066 5 5 13.5066 5 24C5 34.4934 13.5066 43 24 43Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6804 19.8627C30.1065 19.4366 30.1065 18.7458 29.6804 18.3196C29.2542 17.8935 28.5634 17.8935 28.1373 18.3196L24 22.4569L25.5431 24L29.6804 19.8627Z",
    fill: "#181818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.034 23.5581L14.0767 32.5154C13.688 32.9041 13.688 33.5343 14.0767 33.923C14.2711 34.1172 14.5257 34.2145 14.7804 34.2145C15.0351 34.2145 15.2899 34.1173 15.4841 33.923L24.4415 24.9657L23.034 23.5581Z",
    fill: "#EE3840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2513 15.3863C16.7362 14.8712 15.9013 14.8712 15.3863 15.3863C14.8712 15.9014 14.8712 16.7363 15.3863 17.2513L22.135 24L24 22.135L17.2513 15.3863Z",
    fill: "#181818"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 26.4881C22.6279 26.4881 21.5117 25.3719 21.5117 23.9999C21.5117 22.6279 22.6279 21.5117 23.9999 21.5117C25.3719 21.5117 26.4881 22.6279 26.4881 23.9999C26.4881 25.3719 25.3719 26.4881 23.9999 26.4881Z",
    fill: "#524E4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4569 24.9952H10.964C10.4143 24.9952 9.96875 24.5495 9.96875 23.9999C9.96875 23.4503 10.4143 23.0046 10.964 23.0046H12.4569C13.0066 23.0046 13.4522 23.4503 13.4522 23.9999C13.4522 24.5495 13.0066 24.9952 12.4569 24.9952Z",
    fill: "#7A7674"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0031 13.4502C23.4534 13.4502 23.0078 13.0045 23.0078 12.4549V10.9621C23.0078 10.4125 23.4534 9.9668 24.0031 9.9668C24.5528 9.9668 24.9984 10.4125 24.9984 10.9621V12.455C24.9984 13.0045 24.5528 13.4502 24.0031 13.4502Z",
    fill: "#7A7674"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.039 24.9952H35.5461C34.9964 24.9952 34.5508 24.5495 34.5508 23.9999C34.5508 23.4503 34.9964 23.0046 35.5461 23.0046H37.039C37.5886 23.0046 38.0342 23.4503 38.0342 23.9999C38.0342 24.5495 37.5886 24.9952 37.039 24.9952Z",
    fill: "#7A7674"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0031 38.0331C23.4534 38.0331 23.0078 37.5875 23.0078 37.0379V35.545C23.0078 34.9954 23.4534 34.5497 24.0031 34.5497C24.5528 34.5497 24.9984 34.9954 24.9984 35.545V37.0379C24.9984 37.5875 24.5528 38.0331 24.0031 38.0331Z",
    fill: "#7A7674"
  })));
};
export default SvgIntermittentFasting;